// API client — Mandats (Lot M1).
import { api as _api } from "@/lib/api";

const BASE = process.env.REACT_APP_BACKEND_URL || "";

async function req(path, opts = {}) {
  const { method = "GET", body } = opts;
  const res = await fetch(`${BASE}${path}`, {
    method,
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: body ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : null;
  if (!res.ok) {
    const err = new Error(data?.detail || `HTTP ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return data;
}

export const mandatesApi = {
  list: (params = {}) => {
    const q = new URLSearchParams();
    if (params.status) q.set("status", params.status);
    if (params.seller_id) q.set("seller_id", params.seller_id);
    const qs = q.toString();
    return req(`/api/mandates${qs ? `?${qs}` : ""}`);
  },
  create: (payload) => req("/api/mandates", { method: "POST", body: payload }),
  get:    (id) => req(`/api/mandates/${id}`),
  patch:  (id, patch) => req(`/api/mandates/${id}`, { method: "PATCH", body: patch }),
  regenerateCode: (id) => req(`/api/mandates/${id}/regenerate-code`, { method: "POST" }),
  generateMagicLink: (id) => req(`/api/mandates/${id}/magic-link`, { method: "POST" }),
  revokeAccess: (id) => req(`/api/mandates/${id}/revoke-access`, { method: "POST" }),
};

export const sellersApi = {
  list:   () => req("/api/sellers"),
  create: (payload) => req("/api/sellers", { method: "POST", body: payload }),
  get:    (id) => req(`/api/sellers/${id}`),
  patch:  (id, patch) => req(`/api/sellers/${id}`, { method: "PATCH", body: patch }),
};

export default mandatesApi;
